export default {
  lang: 'en',
  messages: {
    'app.title': 'PARIS',
    'app.copyright': '© {copyrightYear} International Post Corporation',
    'app.signIn': 'sign in',
    'app.signOut': 'sign out',
    'message.notFound': '404: Page not found',
    'button.login': 'Login',
    'error.credentials.invalid': 'Incorrect credentials',
  },
};
